import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "pagestyle" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { style: {"flex":"auto"} }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter()
  const propss = {
    expandTrigger: 'hover' as const,
    value:'ID',
    label:'Title',
    children:'Children',
  }
  const searchForm:any = reactive({
    cate:"",
    cates:[],
    words:"",
    limit:10,
    page:1,
  })
  const endTimeForm:any = reactive({
    id:"",
    end_time:"",
    remark:"",
  })
  const baseData = reactive({
    loading:false,
    title:'',
    endTimeBox:false,
    cateslist:[],
    showloglistbox:false,
    showlogtitle:"",
    loglist:[],
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleChange = (value:any) => {
    searchForm.cate = value[value.length - 1]
  }
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.cate = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const showlog = (id:string,title:string) => {
    baseData.showloglistbox = true
    baseData.showlogtitle = title
    api.companyApi.getLogList({id:id}).then((res:any)=>{
      if(res.code==200){
        baseData.loglist = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const showEndTimeBox = (id:string,end_time:string) => {
    baseData.endTimeBox = true
    endTimeForm.id = id
    endTimeForm.end_time = end_time
    endTimeForm.remark = ""
  }
  const setEndTime = () =>{
    api.companyApi.setEndTime(endTimeForm).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.endTimeBox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    localStorage.setItem('companyspage',searchForm.page);
    localStorage.setItem('companyscate',searchForm.cate);
    localStorage.setItem('companyswords',searchForm.words);
    localStorage.setItem('companyslimit',searchForm.limit);
    baseData.loading = true
    api.companyApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].Status = res.data.list[i].Status==1?true:false
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    router.push("/company/add");
  }
  const edit = (id:any) => {
    router.push("/company/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.companyApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCatesList = () => {
    baseData.loading = true
    api.companyApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const defaultProps = {
    children: 'children',
    label: 'catagory_name',
    value: 'catagoryid',
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('companyspage') ? parseInt(localStorage.getItem('companyspage')) : 1;
    searchForm.cate = localStorage.getItem('companyscate') ? localStorage.getItem('companyscate') : '';
    searchForm.words = localStorage.getItem('companyswords') ? localStorage.getItem('companyswords') : '';
    searchForm.limit = localStorage.getItem('companyslimit') ? parseInt(localStorage.getItem('companyslimit')) : 10;
    getList()
    getCatesList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("公司列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建公司")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: searchForm,
          inline: "",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "公司分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: searchForm.cates,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.cates) = $event)),
                  options: baseData.cateslist,
                  props: propss,
                  clearable: "",
                  onChange: handleChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "关键词" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: searchForm.words,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.words) = $event)),
                  placeholder: "公司名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: reset }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "公司名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "catagory_name",
              label: "分类名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "phone",
              label: "手机号码",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "wxcode",
              label: "微信号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "website",
              label: "网址"
            }),
            _createVNode(_component_el_table_column, {
              prop: "address",
              label: "公司地址"
            }),
            _createVNode(_component_el_table_column, {
              prop: "end_time",
              label: "到期时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "状态",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status==0)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 0,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status==1)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 1,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待审核")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status==2)
                  ? (_openBlock(), _createBlock(_component_el_text, {
                      key: 2,
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "310"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (showEndTimeBox(scope.row.id,scope.row.end_time)),
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("设置到期时间")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (showlog(scope.row.id, scope.row.title))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("记录")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (del(scope.row.id)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.endTimeBox,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((baseData.endTimeBox) = $event)),
      title: "设置到期时间",
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (baseData.endTimeBox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (setEndTime()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: endTimeForm,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "到期时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: endTimeForm.end_time,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((endTimeForm.end_time) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: endTimeForm.remark,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((endTimeForm.remark) = $event)),
                  autocomplete: "off",
                  rows: 2,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: baseData.showloglistbox,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((baseData.showloglistbox) = $event))
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(baseData.showlogtitle), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_timeline, { style: {"max-width":"600px"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.loglist, (activity, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: activity.created_at
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(activity.remark), 1),
                    _createElementVNode("p", null, "操作人：" + _toDisplayString(activity.username), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (baseData.showloglistbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})